import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const pillars = ['Organización', 'Presupuesto', 'Decoración', 'Juegos', 'Mesa Dulce', 'Animación'];
const tomos = [{
  n: 1,
  title: 'El Cronograma Maestro',
  desc: 'La hoja de ruta definitiva. Qué hacer 30, 15 y 7 días antes para llegar al día del cumple con control total y cero improvisación.'
}, {
  n: 2,
  title: 'Ingeniería del Presupuesto Real',
  desc: 'Cómo blindar tu billetera contra la inflación. Estrategias para priorizar gastos y hacer que cada peso rinda al máximo.'
}, {
  n: 3,
  title: 'Temáticas que Son Tendencia',
  desc: 'Los 20 temas más pedidos en Argentina. Cómo elegir el concepto que va a enloquecer de alegría a tu hijo.'
}, {
  n: 4,
  title: 'Decoración DIY Paso a Paso',
  desc: 'Cómo crear un ambiente mágico sin ser experta. Secretos para usar globos, telas y papel con resultados profesionales.'
}, {
  n: 5,
  title: 'La Mesa Dulce Impecable',
  desc: 'Recetas rendidoras, armado de Candy Bar estético y cómo calcular cantidades exactas para que no sobre ni falte nada.'
}, {
  n: 6,
  title: 'Menú para Adultos y Chicos',
  desc: 'Comida real para gente real. Opciones económicas, fáciles de servir, que a todos les encantan sin catering caro.'
}, {
  n: 7,
  title: 'Manual de Juegos y Dinámicas',
  desc: 'El antídoto contra el aburrimiento. Juegos probados que mantienen a los chicos entretenidos y felices sin tecnología.'
}, {
  n: 8,
  title: 'Animación para "Padres en Apuros"',
  desc: 'Cómo liderar la fiesta sin contratar servicios externos. Técnicas de manejo de grupo para evitar el caos total.'
}, {
  n: 9,
  title: 'Invitaciones y Comunicación Digital',
  desc: 'Qué información no puede faltar, cómo manejar confirmaciones y crear expectativa desde el primer WhatsApp.'
}, {
  n: 10,
  title: 'Fotografía y Recuerdos con Celular',
  desc: 'Ángulos, iluminación natural y las mejores apps gratuitas para capturar momentos épicos sin fotógrafo profesional.'
}, {
  n: 11,
  title: 'Souvenirs y Bolsitas Creativas',
  desc: 'Ideas de regalos que los chicos no tiran a la basura. Opciones low-cost que dejan una huella positiva duradera.'
}, {
  n: 12,
  title: 'Gestión del "Día D" y Post-Fiesta',
  desc: 'Logística del día del evento: desde que te despertás hasta que el último invitado se va. Cierre y recuerdos para siempre.'
}];
const includes = ['Checklists de implementación', 'Protocolos paso a paso', 'Plantillas editables', 'Ejemplos del mercado ARG', 'Estrategias anti-inflación', 'Casos reales de mamás', 'Recetas e ideas DIY', 'Listo para aplicar desde hoy'];
export function Tomos() {
  return <section aria-label="Los 12 tomos" className="bg-ink" data-id="element-158" data-mp="32no1r2bqrlzw">
      <div className="mx-auto max-w-6xl px-5 pt-[4px] pb-[28px]" data-id="element-159" data-mp="2xns0haufi8o1">
        <div className="pt-[5px] text-center" data-id="element-160" data-mp="2xpcsaspczdi7">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-iris-soft" data-id="element-161" data-mp="3h8salpmsv0dp">
            🏆 MegaPack™ Fiesta Épica
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-white sm:text-4xl" data-id="element-162" data-mp="3ladi0vgkemgi">
            12 Tomos + 5 Bonos
          </h2>
          <p className="mt-2 text-base text-white/60" data-id="element-163" data-mp="3ca8l5f8zz6gl">100+ páginas — Todo resuelto.</p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-164" data-mp="3cc1syxvcjwq6">
            {pillars.map(p => <span key={p} className="rounded-full border border-azure/30 bg-azure/10 px-3 py-1 text-xs font-bold uppercase tracking-wide text-azure" data-id="element-165" data-mp="2xjhqlzg0tt9s">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-166" data-mp="2tjzbjkavscev">
          {tomos.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06
        }} className="group rounded-2xl border border-white/10 bg-ink-2 p-5 pt-[7px] transition-colors duration-200 hover:border-iris/50" data-id="element-167" data-mp="2eojj1jpy8okl" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-168" data-mp="387uhji3s0jbh">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-iris/20 font-display text-lg font-black text-iris-soft" data-id="element-169" data-mp="387axnvukfkut">
                  {t.n}
                </span>
                <h3 className="text-sm font-bold leading-tight text-white" data-id="element-170" data-mp="2z8z87x5fqt3y">{t.title}</h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-171" data-mp="2u9w4cg16ysxk">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-white/10 bg-ink-2 p-6" data-id="element-172" data-mp="sgyconj5i6e7">
          <p className="text-center text-sm font-bold uppercase tracking-wide text-white/70" data-id="element-173" data-mp="nhlhnfi4lt0j">
            ✅ Cada tomo incluye
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-174" data-mp="v036qu2hjgem">
            {includes.map(item => <li key={item} className="flex items-center gap-2 text-sm text-white/75" data-id="element-175" data-mp="zyd4ncflgv3x">
                <CheckIcon className="h-4 w-4 shrink-0 text-iris-soft" strokeWidth={3} data-id="element-176" data-mp="14rz4g40nt4ib" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}